import React from 'react';
import { Menu } from 'evergreen-ui';

const CredentialMenu = ({ onEditClick, onDeleteClick }: any) => {
  return (
    <Menu>
      <Menu.Group>
        <Menu.Item onSelect={onEditClick}>Edit credential</Menu.Item>
      </Menu.Group>
      <Menu.Divider />
      <Menu.Group>
        <Menu.Item intent="danger" onSelect={onDeleteClick}>
          Delete credential
        </Menu.Item>
      </Menu.Group>
    </Menu>
  );
};

export default CredentialMenu;
